import { render, staticRenderFns } from "./EditCmp.vue?vue&type=template&id=8cb0e1c0&scoped=true"
import script from "./EditCmp.vue?vue&type=script&lang=js"
export * from "./EditCmp.vue?vue&type=script&lang=js"
import style0 from "./EditCmp.vue?vue&type=style&index=0&id=8cb0e1c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb0e1c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cb0e1c0')) {
      api.createRecord('8cb0e1c0', component.options)
    } else {
      api.reload('8cb0e1c0', component.options)
    }
    module.hot.accept("./EditCmp.vue?vue&type=template&id=8cb0e1c0&scoped=true", function () {
      api.rerender('8cb0e1c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Edit/EditCmp.vue"
export default component.exports